import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { QuestionTooltip } from "./QuestionTooltip";
import { YearPickerQuestion as YearPickerQuestionType } from "./questionTypes";

interface YearPickerQuestionProps {
  question: YearPickerQuestionType;
  value: string;
  onChange: (questionId: string, value: string) => void;
}

export function YearPickerQuestion({ question, value, onChange }: YearPickerQuestionProps) {
  const minYear = question.minYear ?? 1950;
  const maxYear = question.maxYear ?? new Date().getFullYear();
  const years: number[] = [];
  for (let y = maxYear; y >= minYear; y--) {
    years.push(y);
  }

  return (
    <div className="space-y-8 w-full max-w-4xl mr-auto py-4 min-h-[400px] text-left">
      <div>
        <h2 className="text-2xl font-bold text-foreground mb-3">{question.title}</h2>
        {question.description && <p className="text-muted-foreground">{question.description}</p>}
        {question.tooltip && <QuestionTooltip tooltip={question.tooltip} />}
      </div>

      <Select value={value || ""} onValueChange={(v) => onChange(question.id, v)}>
        <SelectTrigger className="w-full max-w-xs text-lg py-4 px-6 min-h-[60px]">
          <SelectValue placeholder="Select year" />
        </SelectTrigger>
        <SelectContent className="max-h-[300px]">
          {years.map((year) => (
            <SelectItem key={year} value={String(year)}>
              {year}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
